// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/circuit-legs.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/circuit-legs/circuit-legs.js';

mount([g0]);
